import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = process.env.REACT_APP_B2B_API_BASE_URL

export const getVendorsListApi = async(searchText, parentCompanyId) => {
  const url = `${env}/admin-api/v1/vendors?search=${searchText || ''}&parentCompanyId=${parentCompanyId || ''}`;
  const res = await requestInstance.get(url)
    .catch((err) => err.response)
  return setCurrentUser(res)
}
